/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RedeemRouteImport } from './routes/redeem'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppMyLearningRouteImport } from './routes/_app.my-learning'
import { Route as AppMyPurchasesRouteImport } from './routes/_app.my-purchases'
import { Route as AppMySessionsRouteImport } from './routes/_app.my-sessions'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as MarketingIndexRouteImport } from './routes/_marketing.index'
import { Route as MarketingAboutRouteImport } from './routes/_marketing.about'
import { Route as MarketingContactRouteImport } from './routes/_marketing.contact'
import { Route as MarketingCookiesRouteImport } from './routes/_marketing.cookies'
import { Route as MarketingCoursesRouteImport } from './routes/_marketing.courses'
import { Route as MarketingFaceToFaceTrainingRouteImport } from './routes/_marketing.face-to-face-training'
import { Route as MarketingPrivacyRouteImport } from './routes/_marketing.privacy'
import { Route as MarketingRegisterRouteImport } from './routes/_marketing.register'
import { Route as MarketingTermsRouteImport } from './routes/_marketing.terms'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminOrdersRouteImport } from './routes/admin/orders'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminTrainersRouteImport } from './routes/admin/trainers'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppMySessionsSessionIdRouteImport } from './routes/_app.my-sessions_.$sessionId'
import { Route as AppTrainersTrainerIdRouteImport } from './routes/_app.trainers.$trainerId'
import { Route as MarketingCoursesCourseIdRouteImport } from './routes/_marketing.courses_.$courseId'
import { Route as MarketingFaceToFaceTrainingCourseIdRouteImport } from './routes/_marketing.face-to-face-training_.$courseId'
import { Route as MarketingIltRemindersUnsubscribeRouteImport } from './routes/_marketing.ilt-reminders.unsubscribe'
import { Route as MarketingLearningPathsPathIdRouteImport } from './routes/_marketing.learning-paths.$pathId'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminCoursesCourseIdRouteImport } from './routes/admin/courses/$courseId'
import { Route as AdminCoursesNewRouteImport } from './routes/admin/courses/new'
import { Route as AdminLearningPathsIndexRouteImport } from './routes/admin/learning-paths/index'
import { Route as AdminLearningPathsPathIdRouteImport } from './routes/admin/learning-paths/$pathId'
import { Route as AdminLearningPathsNewRouteImport } from './routes/admin/learning-paths/new'
import { Route as AdminOrdersOrderIdRouteImport } from './routes/admin/orders_.$orderId'
import { Route as AdminTrainersUserIdRouteImport } from './routes/admin/trainers_.$userId'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users_.$userId'
import { Route as AppMyLearningFeedbackBookingIdRouteImport } from './routes/_app.my-learning_.feedback.$bookingId'
import { Route as AppMyPurchasesSeatOrdersSeatOrderIdRouteImport } from './routes/_app.my-purchases_.seat-orders.$seatOrderId'
import { Route as AdminLearningPathsPathIdAssignmentsRouteImport } from './routes/admin/learning-paths/$pathId_.assignments'
import { Route as LearningCoursesCourseIdPlayerRouteImport } from './routes/learning/courses/$courseId.player'
import { Route as AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRouteImport } from './routes/_app.my-purchases_.seat-orders.$seatOrderId_.take-seat'
import { Route as AdminCoursesCourseIdSessionsSessionIdRouteImport } from './routes/admin/courses/$courseId_.sessions.$sessionId'
import { Route as AdminCoursesCourseIdVersionsVersionIdDraftRouteImport } from './routes/admin/courses/$courseId_.versions.$versionId.draft'
import { Route as AdminCoursesCourseIdVersionsVersionIdModulesRouteImport } from './routes/admin/courses/$courseId_.versions.$versionId.modules'
import { Route as AdminCoursesCourseIdVersionsVersionIdPreviewRouteImport } from './routes/admin/courses/$courseId_.versions.$versionId.preview'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RedeemRoute = RedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMyLearningRoute = AppMyLearningRouteImport.update({
  id: '/my-learning',
  path: '/my-learning',
  getParentRoute: () => AppRoute,
} as any)
const AppMyPurchasesRoute = AppMyPurchasesRouteImport.update({
  id: '/my-purchases',
  path: '/my-purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppMySessionsRoute = AppMySessionsRouteImport.update({
  id: '/my-sessions',
  path: '/my-sessions',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingAboutRoute = MarketingAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingContactRoute = MarketingContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingCookiesRoute = MarketingCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingCoursesRoute = MarketingCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingFaceToFaceTrainingRoute =
  MarketingFaceToFaceTrainingRouteImport.update({
    id: '/face-to-face-training',
    path: '/face-to-face-training',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingPrivacyRoute = MarketingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingRegisterRoute = MarketingRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingTermsRoute = MarketingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => MarketingRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
  id: '/admin/notifications',
  path: '/admin/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrdersRoute = AdminOrdersRouteImport.update({
  id: '/admin/orders',
  path: '/admin/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTrainersRoute = AdminTrainersRouteImport.update({
  id: '/admin/trainers',
  path: '/admin/trainers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMySessionsSessionIdRoute = AppMySessionsSessionIdRouteImport.update({
  id: '/my-sessions_/$sessionId',
  path: '/my-sessions/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainersTrainerIdRoute = AppTrainersTrainerIdRouteImport.update({
  id: '/trainers/$trainerId',
  path: '/trainers/$trainerId',
  getParentRoute: () => AppRoute,
} as any)
const MarketingCoursesCourseIdRoute =
  MarketingCoursesCourseIdRouteImport.update({
    id: '/courses_/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingFaceToFaceTrainingCourseIdRoute =
  MarketingFaceToFaceTrainingCourseIdRouteImport.update({
    id: '/face-to-face-training_/$courseId',
    path: '/face-to-face-training/$courseId',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingIltRemindersUnsubscribeRoute =
  MarketingIltRemindersUnsubscribeRouteImport.update({
    id: '/ilt-reminders/unsubscribe',
    path: '/ilt-reminders/unsubscribe',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingLearningPathsPathIdRoute =
  MarketingLearningPathsPathIdRouteImport.update({
    id: '/learning-paths/$pathId',
    path: '/learning-paths/$pathId',
    getParentRoute: () => MarketingRoute,
  } as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/admin/courses/',
  path: '/admin/courses/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCoursesCourseIdRoute = AdminCoursesCourseIdRouteImport.update({
  id: '/admin/courses/$courseId',
  path: '/admin/courses/$courseId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCoursesNewRoute = AdminCoursesNewRouteImport.update({
  id: '/admin/courses/new',
  path: '/admin/courses/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLearningPathsIndexRoute = AdminLearningPathsIndexRouteImport.update({
  id: '/admin/learning-paths/',
  path: '/admin/learning-paths/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLearningPathsPathIdRoute =
  AdminLearningPathsPathIdRouteImport.update({
    id: '/admin/learning-paths/$pathId',
    path: '/admin/learning-paths/$pathId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminLearningPathsNewRoute = AdminLearningPathsNewRouteImport.update({
  id: '/admin/learning-paths/new',
  path: '/admin/learning-paths/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrdersOrderIdRoute = AdminOrdersOrderIdRouteImport.update({
  id: '/admin/orders_/$orderId',
  path: '/admin/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTrainersUserIdRoute = AdminTrainersUserIdRouteImport.update({
  id: '/admin/trainers_/$userId',
  path: '/admin/trainers/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/admin/users_/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMyLearningFeedbackBookingIdRoute =
  AppMyLearningFeedbackBookingIdRouteImport.update({
    id: '/my-learning_/feedback/$bookingId',
    path: '/my-learning/feedback/$bookingId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMyPurchasesSeatOrdersSeatOrderIdRoute =
  AppMyPurchasesSeatOrdersSeatOrderIdRouteImport.update({
    id: '/my-purchases_/seat-orders/$seatOrderId',
    path: '/my-purchases/seat-orders/$seatOrderId',
    getParentRoute: () => AppRoute,
  } as any)
const AdminLearningPathsPathIdAssignmentsRoute =
  AdminLearningPathsPathIdAssignmentsRouteImport.update({
    id: '/admin/learning-paths/$pathId_/assignments',
    path: '/admin/learning-paths/$pathId/assignments',
    getParentRoute: () => rootRouteImport,
  } as any)
const LearningCoursesCourseIdPlayerRoute =
  LearningCoursesCourseIdPlayerRouteImport.update({
    id: '/learning/courses/$courseId/player',
    path: '/learning/courses/$courseId/player',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute =
  AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRouteImport.update({
    id: '/my-purchases_/seat-orders/$seatOrderId_/take-seat',
    path: '/my-purchases/seat-orders/$seatOrderId/take-seat',
    getParentRoute: () => AppRoute,
  } as any)
const AdminCoursesCourseIdSessionsSessionIdRoute =
  AdminCoursesCourseIdSessionsSessionIdRouteImport.update({
    id: '/admin/courses/$courseId_/sessions/$sessionId',
    path: '/admin/courses/$courseId/sessions/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCoursesCourseIdVersionsVersionIdDraftRoute =
  AdminCoursesCourseIdVersionsVersionIdDraftRouteImport.update({
    id: '/admin/courses/$courseId_/versions/$versionId/draft',
    path: '/admin/courses/$courseId/versions/$versionId/draft',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCoursesCourseIdVersionsVersionIdModulesRoute =
  AdminCoursesCourseIdVersionsVersionIdModulesRouteImport.update({
    id: '/admin/courses/$courseId_/versions/$versionId/modules',
    path: '/admin/courses/$courseId/versions/$versionId/modules',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCoursesCourseIdVersionsVersionIdPreviewRoute =
  AdminCoursesCourseIdVersionsVersionIdPreviewRouteImport.update({
    id: '/admin/courses/$courseId_/versions/$versionId/preview',
    path: '/admin/courses/$courseId/versions/$versionId/preview',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/redeem': typeof RedeemRoute
  '/reset-password': typeof ResetPasswordRoute
  '/my-learning': typeof AppMyLearningRoute
  '/my-purchases': typeof AppMyPurchasesRoute
  '/my-sessions': typeof AppMySessionsRoute
  '/profile': typeof AppProfileRoute
  '/about': typeof MarketingAboutRoute
  '/contact': typeof MarketingContactRoute
  '/cookies': typeof MarketingCookiesRoute
  '/courses': typeof MarketingCoursesRoute
  '/face-to-face-training': typeof MarketingFaceToFaceTrainingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/register': typeof MarketingRegisterRoute
  '/terms': typeof MarketingTermsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/trainers': typeof AdminTrainersRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/': typeof AdminIndexRoute
  '/my-sessions/$sessionId': typeof AppMySessionsSessionIdRoute
  '/trainers/$trainerId': typeof AppTrainersTrainerIdRoute
  '/courses/$courseId': typeof MarketingCoursesCourseIdRoute
  '/face-to-face-training/$courseId': typeof MarketingFaceToFaceTrainingCourseIdRoute
  '/ilt-reminders/unsubscribe': typeof MarketingIltRemindersUnsubscribeRoute
  '/learning-paths/$pathId': typeof MarketingLearningPathsPathIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/courses/new': typeof AdminCoursesNewRoute
  '/admin/learning-paths/$pathId': typeof AdminLearningPathsPathIdRoute
  '/admin/learning-paths/new': typeof AdminLearningPathsNewRoute
  '/admin/orders/$orderId': typeof AdminOrdersOrderIdRoute
  '/admin/trainers/$userId': typeof AdminTrainersUserIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/learning-paths/': typeof AdminLearningPathsIndexRoute
  '/my-learning/feedback/$bookingId': typeof AppMyLearningFeedbackBookingIdRoute
  '/my-purchases/seat-orders/$seatOrderId': typeof AppMyPurchasesSeatOrdersSeatOrderIdRoute
  '/admin/learning-paths/$pathId/assignments': typeof AdminLearningPathsPathIdAssignmentsRoute
  '/learning/courses/$courseId/player': typeof LearningCoursesCourseIdPlayerRoute
  '/my-purchases/seat-orders/$seatOrderId/take-seat': typeof AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute
  '/admin/courses/$courseId/sessions/$sessionId': typeof AdminCoursesCourseIdSessionsSessionIdRoute
  '/admin/courses/$courseId/versions/$versionId/draft': typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  '/admin/courses/$courseId/versions/$versionId/modules': typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  '/admin/courses/$courseId/versions/$versionId/preview': typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}
export interface FileRoutesByTo {
  '/': typeof MarketingIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/redeem': typeof RedeemRoute
  '/reset-password': typeof ResetPasswordRoute
  '/my-learning': typeof AppMyLearningRoute
  '/my-purchases': typeof AppMyPurchasesRoute
  '/my-sessions': typeof AppMySessionsRoute
  '/profile': typeof AppProfileRoute
  '/about': typeof MarketingAboutRoute
  '/contact': typeof MarketingContactRoute
  '/cookies': typeof MarketingCookiesRoute
  '/courses': typeof MarketingCoursesRoute
  '/face-to-face-training': typeof MarketingFaceToFaceTrainingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/register': typeof MarketingRegisterRoute
  '/terms': typeof MarketingTermsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/trainers': typeof AdminTrainersRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin': typeof AdminIndexRoute
  '/my-sessions/$sessionId': typeof AppMySessionsSessionIdRoute
  '/trainers/$trainerId': typeof AppTrainersTrainerIdRoute
  '/courses/$courseId': typeof MarketingCoursesCourseIdRoute
  '/face-to-face-training/$courseId': typeof MarketingFaceToFaceTrainingCourseIdRoute
  '/ilt-reminders/unsubscribe': typeof MarketingIltRemindersUnsubscribeRoute
  '/learning-paths/$pathId': typeof MarketingLearningPathsPathIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/courses/new': typeof AdminCoursesNewRoute
  '/admin/learning-paths/$pathId': typeof AdminLearningPathsPathIdRoute
  '/admin/learning-paths/new': typeof AdminLearningPathsNewRoute
  '/admin/orders/$orderId': typeof AdminOrdersOrderIdRoute
  '/admin/trainers/$userId': typeof AdminTrainersUserIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/learning-paths': typeof AdminLearningPathsIndexRoute
  '/my-learning/feedback/$bookingId': typeof AppMyLearningFeedbackBookingIdRoute
  '/my-purchases/seat-orders/$seatOrderId': typeof AppMyPurchasesSeatOrdersSeatOrderIdRoute
  '/admin/learning-paths/$pathId/assignments': typeof AdminLearningPathsPathIdAssignmentsRoute
  '/learning/courses/$courseId/player': typeof LearningCoursesCourseIdPlayerRoute
  '/my-purchases/seat-orders/$seatOrderId/take-seat': typeof AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute
  '/admin/courses/$courseId/sessions/$sessionId': typeof AdminCoursesCourseIdSessionsSessionIdRoute
  '/admin/courses/$courseId/versions/$versionId/draft': typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  '/admin/courses/$courseId/versions/$versionId/modules': typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  '/admin/courses/$courseId/versions/$versionId/preview': typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_marketing': typeof MarketingRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/redeem': typeof RedeemRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/my-learning': typeof AppMyLearningRoute
  '/_app/my-purchases': typeof AppMyPurchasesRoute
  '/_app/my-sessions': typeof AppMySessionsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_marketing/about': typeof MarketingAboutRoute
  '/_marketing/contact': typeof MarketingContactRoute
  '/_marketing/cookies': typeof MarketingCookiesRoute
  '/_marketing/courses': typeof MarketingCoursesRoute
  '/_marketing/face-to-face-training': typeof MarketingFaceToFaceTrainingRoute
  '/_marketing/privacy': typeof MarketingPrivacyRoute
  '/_marketing/register': typeof MarketingRegisterRoute
  '/_marketing/terms': typeof MarketingTermsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/trainers': typeof AdminTrainersRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/_app/my-sessions_/$sessionId': typeof AppMySessionsSessionIdRoute
  '/_app/trainers/$trainerId': typeof AppTrainersTrainerIdRoute
  '/_marketing/courses_/$courseId': typeof MarketingCoursesCourseIdRoute
  '/_marketing/face-to-face-training_/$courseId': typeof MarketingFaceToFaceTrainingCourseIdRoute
  '/_marketing/ilt-reminders/unsubscribe': typeof MarketingIltRemindersUnsubscribeRoute
  '/_marketing/learning-paths/$pathId': typeof MarketingLearningPathsPathIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/courses/new': typeof AdminCoursesNewRoute
  '/admin/learning-paths/$pathId': typeof AdminLearningPathsPathIdRoute
  '/admin/learning-paths/new': typeof AdminLearningPathsNewRoute
  '/admin/orders_/$orderId': typeof AdminOrdersOrderIdRoute
  '/admin/trainers_/$userId': typeof AdminTrainersUserIdRoute
  '/admin/users_/$userId': typeof AdminUsersUserIdRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/learning-paths/': typeof AdminLearningPathsIndexRoute
  '/_app/my-learning_/feedback/$bookingId': typeof AppMyLearningFeedbackBookingIdRoute
  '/_app/my-purchases_/seat-orders/$seatOrderId': typeof AppMyPurchasesSeatOrdersSeatOrderIdRoute
  '/admin/learning-paths/$pathId_/assignments': typeof AdminLearningPathsPathIdAssignmentsRoute
  '/learning/courses/$courseId/player': typeof LearningCoursesCourseIdPlayerRoute
  '/_app/my-purchases_/seat-orders/$seatOrderId_/take-seat': typeof AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute
  '/admin/courses/$courseId_/sessions/$sessionId': typeof AdminCoursesCourseIdSessionsSessionIdRoute
  '/admin/courses/$courseId_/versions/$versionId/draft': typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  '/admin/courses/$courseId_/versions/$versionId/modules': typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  '/admin/courses/$courseId_/versions/$versionId/preview': typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/redeem'
    | '/reset-password'
    | '/my-learning'
    | '/my-purchases'
    | '/my-sessions'
    | '/profile'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/courses'
    | '/face-to-face-training'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/admin/analytics'
    | '/admin/notifications'
    | '/admin/orders'
    | '/admin/roles'
    | '/admin/trainers'
    | '/admin/users'
    | '/auth/callback'
    | '/admin/'
    | '/my-sessions/$sessionId'
    | '/trainers/$trainerId'
    | '/courses/$courseId'
    | '/face-to-face-training/$courseId'
    | '/ilt-reminders/unsubscribe'
    | '/learning-paths/$pathId'
    | '/admin/courses/$courseId'
    | '/admin/courses/new'
    | '/admin/learning-paths/$pathId'
    | '/admin/learning-paths/new'
    | '/admin/orders/$orderId'
    | '/admin/trainers/$userId'
    | '/admin/users/$userId'
    | '/admin/courses/'
    | '/admin/learning-paths/'
    | '/my-learning/feedback/$bookingId'
    | '/my-purchases/seat-orders/$seatOrderId'
    | '/admin/learning-paths/$pathId/assignments'
    | '/learning/courses/$courseId/player'
    | '/my-purchases/seat-orders/$seatOrderId/take-seat'
    | '/admin/courses/$courseId/sessions/$sessionId'
    | '/admin/courses/$courseId/versions/$versionId/draft'
    | '/admin/courses/$courseId/versions/$versionId/modules'
    | '/admin/courses/$courseId/versions/$versionId/preview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/redeem'
    | '/reset-password'
    | '/my-learning'
    | '/my-purchases'
    | '/my-sessions'
    | '/profile'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/courses'
    | '/face-to-face-training'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/admin/analytics'
    | '/admin/notifications'
    | '/admin/orders'
    | '/admin/roles'
    | '/admin/trainers'
    | '/admin/users'
    | '/auth/callback'
    | '/admin'
    | '/my-sessions/$sessionId'
    | '/trainers/$trainerId'
    | '/courses/$courseId'
    | '/face-to-face-training/$courseId'
    | '/ilt-reminders/unsubscribe'
    | '/learning-paths/$pathId'
    | '/admin/courses/$courseId'
    | '/admin/courses/new'
    | '/admin/learning-paths/$pathId'
    | '/admin/learning-paths/new'
    | '/admin/orders/$orderId'
    | '/admin/trainers/$userId'
    | '/admin/users/$userId'
    | '/admin/courses'
    | '/admin/learning-paths'
    | '/my-learning/feedback/$bookingId'
    | '/my-purchases/seat-orders/$seatOrderId'
    | '/admin/learning-paths/$pathId/assignments'
    | '/learning/courses/$courseId/player'
    | '/my-purchases/seat-orders/$seatOrderId/take-seat'
    | '/admin/courses/$courseId/sessions/$sessionId'
    | '/admin/courses/$courseId/versions/$versionId/draft'
    | '/admin/courses/$courseId/versions/$versionId/modules'
    | '/admin/courses/$courseId/versions/$versionId/preview'
  id:
    | '__root__'
    | '/_app'
    | '/_marketing'
    | '/forgot-password'
    | '/login'
    | '/redeem'
    | '/reset-password'
    | '/_app/my-learning'
    | '/_app/my-purchases'
    | '/_app/my-sessions'
    | '/_app/profile'
    | '/_marketing/about'
    | '/_marketing/contact'
    | '/_marketing/cookies'
    | '/_marketing/courses'
    | '/_marketing/face-to-face-training'
    | '/_marketing/privacy'
    | '/_marketing/register'
    | '/_marketing/terms'
    | '/admin/analytics'
    | '/admin/notifications'
    | '/admin/orders'
    | '/admin/roles'
    | '/admin/trainers'
    | '/admin/users'
    | '/auth/callback'
    | '/_marketing/'
    | '/admin/'
    | '/_app/my-sessions_/$sessionId'
    | '/_app/trainers/$trainerId'
    | '/_marketing/courses_/$courseId'
    | '/_marketing/face-to-face-training_/$courseId'
    | '/_marketing/ilt-reminders/unsubscribe'
    | '/_marketing/learning-paths/$pathId'
    | '/admin/courses/$courseId'
    | '/admin/courses/new'
    | '/admin/learning-paths/$pathId'
    | '/admin/learning-paths/new'
    | '/admin/orders_/$orderId'
    | '/admin/trainers_/$userId'
    | '/admin/users_/$userId'
    | '/admin/courses/'
    | '/admin/learning-paths/'
    | '/_app/my-learning_/feedback/$bookingId'
    | '/_app/my-purchases_/seat-orders/$seatOrderId'
    | '/admin/learning-paths/$pathId_/assignments'
    | '/learning/courses/$courseId/player'
    | '/_app/my-purchases_/seat-orders/$seatOrderId_/take-seat'
    | '/admin/courses/$courseId_/sessions/$sessionId'
    | '/admin/courses/$courseId_/versions/$versionId/draft'
    | '/admin/courses/$courseId_/versions/$versionId/modules'
    | '/admin/courses/$courseId_/versions/$versionId/preview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  MarketingRoute: typeof MarketingRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RedeemRoute: typeof RedeemRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminNotificationsRoute: typeof AdminNotificationsRoute
  AdminOrdersRoute: typeof AdminOrdersRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminTrainersRoute: typeof AdminTrainersRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCoursesCourseIdRoute: typeof AdminCoursesCourseIdRoute
  AdminCoursesNewRoute: typeof AdminCoursesNewRoute
  AdminLearningPathsPathIdRoute: typeof AdminLearningPathsPathIdRoute
  AdminLearningPathsNewRoute: typeof AdminLearningPathsNewRoute
  AdminOrdersOrderIdRoute: typeof AdminOrdersOrderIdRoute
  AdminTrainersUserIdRoute: typeof AdminTrainersUserIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  AdminLearningPathsIndexRoute: typeof AdminLearningPathsIndexRoute
  AdminLearningPathsPathIdAssignmentsRoute: typeof AdminLearningPathsPathIdAssignmentsRoute
  LearningCoursesCourseIdPlayerRoute: typeof LearningCoursesCourseIdPlayerRoute
  AdminCoursesCourseIdSessionsSessionIdRoute: typeof AdminCoursesCourseIdSessionsSessionIdRoute
  AdminCoursesCourseIdVersionsVersionIdDraftRoute: typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  AdminCoursesCourseIdVersionsVersionIdModulesRoute: typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  AdminCoursesCourseIdVersionsVersionIdPreviewRoute: typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redeem': {
      id: '/redeem'
      path: '/redeem'
      fullPath: '/redeem'
      preLoaderRoute: typeof RedeemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/my-learning': {
      id: '/_app/my-learning'
      path: '/my-learning'
      fullPath: '/my-learning'
      preLoaderRoute: typeof AppMyLearningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-purchases': {
      id: '/_app/my-purchases'
      path: '/my-purchases'
      fullPath: '/my-purchases'
      preLoaderRoute: typeof AppMyPurchasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-sessions': {
      id: '/_app/my-sessions'
      path: '/my-sessions'
      fullPath: '/my-sessions'
      preLoaderRoute: typeof AppMySessionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/about': {
      id: '/_marketing/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MarketingAboutRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/contact': {
      id: '/_marketing/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof MarketingContactRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/cookies': {
      id: '/_marketing/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof MarketingCookiesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/courses': {
      id: '/_marketing/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof MarketingCoursesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/face-to-face-training': {
      id: '/_marketing/face-to-face-training'
      path: '/face-to-face-training'
      fullPath: '/face-to-face-training'
      preLoaderRoute: typeof MarketingFaceToFaceTrainingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/privacy': {
      id: '/_marketing/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof MarketingPrivacyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/register': {
      id: '/_marketing/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof MarketingRegisterRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/terms': {
      id: '/_marketing/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof MarketingTermsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/notifications': {
      id: '/admin/notifications'
      path: '/admin/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/orders': {
      id: '/admin/orders'
      path: '/admin/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof AdminOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/trainers': {
      id: '/admin/trainers'
      path: '/admin/trainers'
      fullPath: '/admin/trainers'
      preLoaderRoute: typeof AdminTrainersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/my-sessions_/$sessionId': {
      id: '/_app/my-sessions_/$sessionId'
      path: '/my-sessions/$sessionId'
      fullPath: '/my-sessions/$sessionId'
      preLoaderRoute: typeof AppMySessionsSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trainers/$trainerId': {
      id: '/_app/trainers/$trainerId'
      path: '/trainers/$trainerId'
      fullPath: '/trainers/$trainerId'
      preLoaderRoute: typeof AppTrainersTrainerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/courses_/$courseId': {
      id: '/_marketing/courses_/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof MarketingCoursesCourseIdRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/face-to-face-training_/$courseId': {
      id: '/_marketing/face-to-face-training_/$courseId'
      path: '/face-to-face-training/$courseId'
      fullPath: '/face-to-face-training/$courseId'
      preLoaderRoute: typeof MarketingFaceToFaceTrainingCourseIdRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/ilt-reminders/unsubscribe': {
      id: '/_marketing/ilt-reminders/unsubscribe'
      path: '/ilt-reminders/unsubscribe'
      fullPath: '/ilt-reminders/unsubscribe'
      preLoaderRoute: typeof MarketingIltRemindersUnsubscribeRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/learning-paths/$pathId': {
      id: '/_marketing/learning-paths/$pathId'
      path: '/learning-paths/$pathId'
      fullPath: '/learning-paths/$pathId'
      preLoaderRoute: typeof MarketingLearningPathsPathIdRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/admin/courses/': {
      id: '/admin/courses/'
      path: '/admin/courses'
      fullPath: '/admin/courses/'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId': {
      id: '/admin/courses/$courseId'
      path: '/admin/courses/$courseId'
      fullPath: '/admin/courses/$courseId'
      preLoaderRoute: typeof AdminCoursesCourseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/new': {
      id: '/admin/courses/new'
      path: '/admin/courses/new'
      fullPath: '/admin/courses/new'
      preLoaderRoute: typeof AdminCoursesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/learning-paths/': {
      id: '/admin/learning-paths/'
      path: '/admin/learning-paths'
      fullPath: '/admin/learning-paths/'
      preLoaderRoute: typeof AdminLearningPathsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/learning-paths/$pathId': {
      id: '/admin/learning-paths/$pathId'
      path: '/admin/learning-paths/$pathId'
      fullPath: '/admin/learning-paths/$pathId'
      preLoaderRoute: typeof AdminLearningPathsPathIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/learning-paths/new': {
      id: '/admin/learning-paths/new'
      path: '/admin/learning-paths/new'
      fullPath: '/admin/learning-paths/new'
      preLoaderRoute: typeof AdminLearningPathsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/orders_/$orderId': {
      id: '/admin/orders_/$orderId'
      path: '/admin/orders/$orderId'
      fullPath: '/admin/orders/$orderId'
      preLoaderRoute: typeof AdminOrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/trainers_/$userId': {
      id: '/admin/trainers_/$userId'
      path: '/admin/trainers/$userId'
      fullPath: '/admin/trainers/$userId'
      preLoaderRoute: typeof AdminTrainersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users_/$userId': {
      id: '/admin/users_/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/my-learning_/feedback/$bookingId': {
      id: '/_app/my-learning_/feedback/$bookingId'
      path: '/my-learning/feedback/$bookingId'
      fullPath: '/my-learning/feedback/$bookingId'
      preLoaderRoute: typeof AppMyLearningFeedbackBookingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-purchases_/seat-orders/$seatOrderId': {
      id: '/_app/my-purchases_/seat-orders/$seatOrderId'
      path: '/my-purchases/seat-orders/$seatOrderId'
      fullPath: '/my-purchases/seat-orders/$seatOrderId'
      preLoaderRoute: typeof AppMyPurchasesSeatOrdersSeatOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/learning-paths/$pathId_/assignments': {
      id: '/admin/learning-paths/$pathId_/assignments'
      path: '/admin/learning-paths/$pathId/assignments'
      fullPath: '/admin/learning-paths/$pathId/assignments'
      preLoaderRoute: typeof AdminLearningPathsPathIdAssignmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learning/courses/$courseId/player': {
      id: '/learning/courses/$courseId/player'
      path: '/learning/courses/$courseId/player'
      fullPath: '/learning/courses/$courseId/player'
      preLoaderRoute: typeof LearningCoursesCourseIdPlayerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/my-purchases_/seat-orders/$seatOrderId_/take-seat': {
      id: '/_app/my-purchases_/seat-orders/$seatOrderId_/take-seat'
      path: '/my-purchases/seat-orders/$seatOrderId/take-seat'
      fullPath: '/my-purchases/seat-orders/$seatOrderId/take-seat'
      preLoaderRoute: typeof AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/courses/$courseId_/sessions/$sessionId': {
      id: '/admin/courses/$courseId_/sessions/$sessionId'
      path: '/admin/courses/$courseId/sessions/$sessionId'
      fullPath: '/admin/courses/$courseId/sessions/$sessionId'
      preLoaderRoute: typeof AdminCoursesCourseIdSessionsSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId_/versions/$versionId/draft': {
      id: '/admin/courses/$courseId_/versions/$versionId/draft'
      path: '/admin/courses/$courseId/versions/$versionId/draft'
      fullPath: '/admin/courses/$courseId/versions/$versionId/draft'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionsVersionIdDraftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId_/versions/$versionId/modules': {
      id: '/admin/courses/$courseId_/versions/$versionId/modules'
      path: '/admin/courses/$courseId/versions/$versionId/modules'
      fullPath: '/admin/courses/$courseId/versions/$versionId/modules'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionsVersionIdModulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId_/versions/$versionId/preview': {
      id: '/admin/courses/$courseId_/versions/$versionId/preview'
      path: '/admin/courses/$courseId/versions/$versionId/preview'
      fullPath: '/admin/courses/$courseId/versions/$versionId/preview'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionsVersionIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRouteChildren {
  AppMyLearningRoute: typeof AppMyLearningRoute
  AppMyPurchasesRoute: typeof AppMyPurchasesRoute
  AppMySessionsRoute: typeof AppMySessionsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppMySessionsSessionIdRoute: typeof AppMySessionsSessionIdRoute
  AppTrainersTrainerIdRoute: typeof AppTrainersTrainerIdRoute
  AppMyLearningFeedbackBookingIdRoute: typeof AppMyLearningFeedbackBookingIdRoute
  AppMyPurchasesSeatOrdersSeatOrderIdRoute: typeof AppMyPurchasesSeatOrdersSeatOrderIdRoute
  AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute: typeof AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppMyLearningRoute: AppMyLearningRoute,
  AppMyPurchasesRoute: AppMyPurchasesRoute,
  AppMySessionsRoute: AppMySessionsRoute,
  AppProfileRoute: AppProfileRoute,
  AppMySessionsSessionIdRoute: AppMySessionsSessionIdRoute,
  AppTrainersTrainerIdRoute: AppTrainersTrainerIdRoute,
  AppMyLearningFeedbackBookingIdRoute: AppMyLearningFeedbackBookingIdRoute,
  AppMyPurchasesSeatOrdersSeatOrderIdRoute:
    AppMyPurchasesSeatOrdersSeatOrderIdRoute,
  AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute:
    AppMyPurchasesSeatOrdersSeatOrderIdTakeSeatRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface MarketingRouteChildren {
  MarketingAboutRoute: typeof MarketingAboutRoute
  MarketingContactRoute: typeof MarketingContactRoute
  MarketingCookiesRoute: typeof MarketingCookiesRoute
  MarketingCoursesRoute: typeof MarketingCoursesRoute
  MarketingFaceToFaceTrainingRoute: typeof MarketingFaceToFaceTrainingRoute
  MarketingPrivacyRoute: typeof MarketingPrivacyRoute
  MarketingRegisterRoute: typeof MarketingRegisterRoute
  MarketingTermsRoute: typeof MarketingTermsRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MarketingCoursesCourseIdRoute: typeof MarketingCoursesCourseIdRoute
  MarketingFaceToFaceTrainingCourseIdRoute: typeof MarketingFaceToFaceTrainingCourseIdRoute
  MarketingIltRemindersUnsubscribeRoute: typeof MarketingIltRemindersUnsubscribeRoute
  MarketingLearningPathsPathIdRoute: typeof MarketingLearningPathsPathIdRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingAboutRoute: MarketingAboutRoute,
  MarketingContactRoute: MarketingContactRoute,
  MarketingCookiesRoute: MarketingCookiesRoute,
  MarketingCoursesRoute: MarketingCoursesRoute,
  MarketingFaceToFaceTrainingRoute: MarketingFaceToFaceTrainingRoute,
  MarketingPrivacyRoute: MarketingPrivacyRoute,
  MarketingRegisterRoute: MarketingRegisterRoute,
  MarketingTermsRoute: MarketingTermsRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MarketingCoursesCourseIdRoute: MarketingCoursesCourseIdRoute,
  MarketingFaceToFaceTrainingCourseIdRoute:
    MarketingFaceToFaceTrainingCourseIdRoute,
  MarketingIltRemindersUnsubscribeRoute: MarketingIltRemindersUnsubscribeRoute,
  MarketingLearningPathsPathIdRoute: MarketingLearningPathsPathIdRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  MarketingRoute: MarketingRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RedeemRoute: RedeemRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminNotificationsRoute: AdminNotificationsRoute,
  AdminOrdersRoute: AdminOrdersRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminTrainersRoute: AdminTrainersRoute,
  AdminUsersRoute: AdminUsersRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCoursesCourseIdRoute: AdminCoursesCourseIdRoute,
  AdminCoursesNewRoute: AdminCoursesNewRoute,
  AdminLearningPathsPathIdRoute: AdminLearningPathsPathIdRoute,
  AdminLearningPathsNewRoute: AdminLearningPathsNewRoute,
  AdminOrdersOrderIdRoute: AdminOrdersOrderIdRoute,
  AdminTrainersUserIdRoute: AdminTrainersUserIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  AdminLearningPathsIndexRoute: AdminLearningPathsIndexRoute,
  AdminLearningPathsPathIdAssignmentsRoute:
    AdminLearningPathsPathIdAssignmentsRoute,
  LearningCoursesCourseIdPlayerRoute: LearningCoursesCourseIdPlayerRoute,
  AdminCoursesCourseIdSessionsSessionIdRoute:
    AdminCoursesCourseIdSessionsSessionIdRoute,
  AdminCoursesCourseIdVersionsVersionIdDraftRoute:
    AdminCoursesCourseIdVersionsVersionIdDraftRoute,
  AdminCoursesCourseIdVersionsVersionIdModulesRoute:
    AdminCoursesCourseIdVersionsVersionIdModulesRoute,
  AdminCoursesCourseIdVersionsVersionIdPreviewRoute:
    AdminCoursesCourseIdVersionsVersionIdPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
